export const VideoClip = ({ url }: any) => {
  return (
    <>
      <video
        autoPlay
        loop
        muted
        style={{
          marginTop: "-60px",
          position: "fixed",
          width: "100%",
          height: "100%",
          objectFit: "cover",
          zIndex: -2,
        }}
      >
        <source src={url} />
      </video>
    </>
  );
};
